import type { UploadedFile } from '@/components/files';
import { InlineFileCard } from '@/components/files';

import { MessageContent } from '../reasoningMessageHelpers';

interface UserMessageBubbleProps {
  text: string;
  orgId: number;
  files?: UploadedFile[];
}

/** The user's side of a chat turn: the "You" label, message, and attachments. */
export function UserMessageBubble({
  text,
  orgId,
  files,
}: UserMessageBubbleProps) {
  return (
    <div className='flex justify-end mb-4'>
      <div className='max-w-[85vw] sm:max-w-[500px]'>
        <div className='flex items-center gap-2 justify-end mb-1.5'>
          <p className='text-xs sm:text-sm font-medium text-secondary'>You</p>
        </div>
        <div className='bg-bg-primary border border-border-secondary rounded-bl-lg rounded-br-lg rounded-tl-lg px-3 py-2'>
          <p className='text-sm sm:text-base font-normal text-fg-primary leading-6 whitespace-pre-wrap break-words'>
            <MessageContent text={text} orgId={orgId} />
          </p>
          {files && files.length > 0 && <AttachedFiles files={files} />}
        </div>
      </div>
    </div>
  );
}

function AttachedFiles({ files }: { files: UploadedFile[] }) {
  return (
    <div className='mt-4 pt-3 border-t border-border-secondary/50'>
      <div className='flex items-center gap-1.5 mb-2'>
        <PaperclipIcon />
        <span className='text-xs font-medium text-tertiary'>
          {files.length} {files.length === 1 ? 'file' : 'files'} attached
        </span>
      </div>
      <div className='flex flex-wrap gap-2'>
        {files.map(file => (
          <InlineFileCard key={file.id} file={file} />
        ))}
      </div>
    </div>
  );
}

function PaperclipIcon() {
  return (
    <svg
      className='size-4 text-tertiary'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth={2}
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13'
      />
    </svg>
  );
}
